// Textos dos aplicativos (Integrações → Painel de Aplicativos) na conversa e
// em tela cheia. Mesmo esquema de ../sgp/i18n.js.

const PT = {
  NEUXS_APLICATIVOS: {
    TITULO: 'Aplicativos',
    INICIO: 'Início',
    INICIO_DICA: 'Volta para o endereço cadastrado do aplicativo',
    NOVA_ABA: 'Nova aba',
    NOVA_ABA_DICA:
      'Abre no navegador. Use se o site não deixar abrir aqui dentro.',
    SEM_ENDERECO: 'Este aplicativo não tem endereço cadastrado.',
    NENHUM:
      'Nenhum aplicativo cadastrado. O administrador cadastra em Configurações → Integrações → Painel de Aplicativos.',
  },
};

export default { pt_BR: PT, en: PT };
